import React, { PropsWithChildren } from 'react';
import { css } from '@landr/styled-system/css';
import { Box } from '@landr/maestro';

// on some device / viewport, a 1px line was visible
// position negatively and add to width and height to prevent this
export const backgroundOverlayWrapperStyles = css({
    position: 'absolute',
    top: '-2xs',
    left: '-2xs',
    right: '-2xs',
    bottom: '-2xs',
    width: 'calc(100% + {sizes.2xs} + {sizes.2xs})',
    height: 'calc(100% + {sizes.2xs} + {sizes.2xs})',
});

const BackgroundOverlay: React.FC<PropsWithChildren> = ({ children }) => {
    return <Box className={backgroundOverlayWrapperStyles}>{children}</Box>;
};

BackgroundOverlay.displayName = 'Section.BackgroundOverlay';

export default BackgroundOverlay;
